import { createBrowserRouter, Navigate, useParams } from 'react-router-dom';

function RedirectToTeamPage() {
  const { eventId, teamId } = useParams();
  return <Navigate to={`/events/${eventId}/teams/${teamId}`} replace />;
}
import { AppLayout } from './layouts/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { HomePage } from './pages/HomePage';
import { EventListPage } from './pages/EventListPage';
import { EventCreatePage } from './pages/EventCreatePage';
import { EventDetailPage } from './pages/EventDetailPage';
import { TeamCreatePage } from './pages/TeamCreatePage';
import { TeamJoinPage } from './pages/TeamJoinPage';
import { TeamDashboardPage } from './pages/TeamDashboardPage';
import { SubmissionEditorPage } from './pages/SubmissionEditorPage';
import { JudgingPanelPage } from './pages/JudgingPanelPage';
import { LiveControlPage } from './pages/LiveControlPage';
import { LiveJudgeViewPage } from './pages/LiveJudgeViewPage';
import { LiveDisplayPage } from './pages/LiveDisplayPage';
import { EventEditPage } from './pages/EventEditPage';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { BreakthroughPage } from './pages/BreakthroughPage';
import { PersonasPage } from './pages/PersonasPage';
import { GuidePage } from './pages/GuidePage';
import { BlueprintPage } from './pages/BlueprintPage';
import { MandatePage } from './pages/MandatePage';

export const router = createBrowserRouter([
  // Auth — no layout, own page chrome
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },

  // Legacy Cognito callback — send to new login
  { path: '/auth/callback', element: <Navigate to="/login" replace /> },

  // Live display — full screen, no header (for projectors)
  { path: '/events/:eventId/live/display', element: <LiveDisplayPage /> },

  // Main app
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },

      // Events
      { path: 'events', element: <EventListPage /> },
      { path: 'events/new', element: <EventCreatePage /> },
      { path: 'events/:eventId', element: <EventDetailPage /> },
      { path: 'events/:eventId/edit', element: <EventEditPage /> },
      { path: 'events/:eventId/leaderboard', element: <LeaderboardPage /> },

      // Teams
      { path: 'events/:eventId/teams/new', element: <TeamCreatePage /> },
      { path: 'events/:eventId/teams/join', element: <TeamJoinPage /> },
      { path: 'events/:eventId/teams/:teamId', element: <TeamDashboardPage /> },

      // Submissions
      { path: 'events/:eventId/teams/:teamId/submit', element: <SubmissionEditorPage /> },
      // Legacy view-only path now redirects into the merged team page.
      {
        path: 'events/:eventId/teams/:teamId/view',
        element: <RedirectToTeamPage />,
      },

      // Judging
      { path: 'events/:eventId/judge/:teamId', element: <JudgingPanelPage /> },

      // Live Mode
      { path: 'events/:eventId/live', element: <LiveControlPage /> },
      { path: 'events/:eventId/live/judge', element: <LiveJudgeViewPage /> },

      // Resources
      { path: 'breakthrough', element: <BreakthroughPage /> },
      { path: 'personas', element: <PersonasPage /> },
      { path: 'guide', element: <GuidePage /> },
      { path: 'blueprint', element: <BlueprintPage /> },
      { path: 'mandate', element: <MandatePage /> },

      // Admin
      { path: 'admin/users', element: <AdminUsersPage /> },
    ],
  },

  // Catch-all
  { path: '*', element: <Navigate to="/" replace /> },
]);
